import styles from '../styles/WelcomeCard.module.css'
export const ConnectButton = (props) => {
    return (<button onClick={props.onClick}  className={styles.btn}>{props.name}</button>);
}